/*eslint @typescript-eslint/no-unused-vars: "off"*/
import React, { useState, useContext, useEffect, useRef } from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  TextareaAutosize,
} from "@mui/material";
import { makeStyles } from "@material-ui/core";
import ModalCloseIcon from "../../assets/images/icon/modalCloseIconBlack";
import palette from "../../theme/palette";
import { trackingService } from "../../services/tracking";
import { UserTypeContext } from "../../context/userStatus";
import { UpdateUserLevelModal } from "../../interfaces/outcomeModal";
import { ButtonLoader } from "../../components/buttonLoader";
import useWidth from "../../utils/useWidth";
import QuesclosePopup from "./QuesclosePopup";
import DeleteIcon from "../../assets/images/icon/DeleteIcon";
import {
  addCategoryJourneyAction,
  addJourneyAction,
} from "../../store/actions/userTypeAction";
import { AddUpdateEventModal } from "./addTrackingEventInfluenceModal";
import typography, { pxToRem } from "../../theme/typography";
import moment from "moment";
import CommonTypo from "../../components/CommonTypo";
import MicIcon from "../../assets/images/icon/MicIcon";
import MicOffIcon from "../../assets/images/icon/MicOffIcon";
const PlusIcon = require("../../assets/images/Add.png");

const useStyles = makeStyles((theme) => ({
  registrationHeading: {
    color: `${palette.primary.light}!important`,
    marginBottom: "20px!important",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px!important",
    },
  },
  pageTitle: {
    marginBottom: "16px!important",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "0px!important",
    },
  },
  dialogTitle: {
    color: `${palette.primary.light}!important`,
    fontSize: "26px!important",
    lineHeight: "26px!important",
    letterSpacing: "0.02em",
    marginBottom: "40px!important",
    padding: "0!important",
  },
  bottomButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    "& button:nth-child(2)": {
      // marginLeft: "24px",
      marginBottom: "0px !important",
    },
  },
  listItemNotes: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    alignSelf: "stretch",
    listStyleType: "none",
    // fontSize: "14px",
    // lineHeight: "14px",
    // color: palette.primary.light,
    // margin: 0,
    paddingLeft: "0px",
    // marginBottom: "20px",
    "& li": {
      display: "flex",
      justifyContent: "space-between",
      // alignItems: "center",
      // padding: '20px',
      alignItems: "flex-start",
      alignSelf: "stretch",
    },
  },
  textarea: {
    width: "100%",
    padding: "16px",
    fontFamily: typography.fontFamily,
    fontSize: "16px",
    fontWeight: 400,
    resize: "vertical",
    border: `1px solid var(--color-border) !important`,
    marginBottom: `0px !important`,
    marginTop: "6px",
    "&:focus-visible": {
      outline: "red"
    },
    "&::placeholder": {
      fontSize: `16px !important`,
      color: "var(--color-text-secondary) !important",
      opacity: 1
    }
  },
  textareaMobile: {
    width: "100%",
    padding: "16px",
    fontFamily: typography.fontFamily,
    fontSize: "14px",
    fontWeight: 400,
    resize: "vertical",
    border: `1px solid var(--color-border) !important`,
    marginBottom: `0px !important`,
    marginTop: "6px",
    "&:focus-visible": {
      outline: "red"
    },
    "&::placeholder": {
      fontSize: `14px !important`,
      color: "var(--color-text-secondary) !important"
    }
  },
  paddingRight: {
    paddingRight: "55px",
  },
}));

interface AddRefQues {
  setOpenRefQuesModal: (openRefQues: boolean) => void;
  refId: string;
  setShowSnakbar: (showSnakbar: boolean) => void;
  setSnakbarMsg: (snakbarMsg: string) => void;
  setMsgType: (msgType: string) => void;
  setRefId: (refId: string) => void;
  isEdit: boolean;
  setIsEdit: any;
  journeyData: any;
  headerDate: any;
  callService: any;
  item: any;
  callToGetData?: boolean;
  isMobile?: boolean;
  renderToNextInput?: any;
  pushIntoData?: (x: any) => void;
}
const AddRefQuesModal = (props: AddRefQues) => {
  const classes = useStyles();
  const inputRef = useRef(null);
  // Ref for textarea
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
  const recognitionRef = useRef(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { state: outcomeState, dispatch: UserTypeDispatch } =
    useContext(UserTypeContext);
  const [openStartModal, setStartModal] = useState(true);
  const [questionValue, setQuestionValue] = useState<any>("");
  const [questionArr, setQuestionArr] = useState([]);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [showLoadingButton, setShowLoadingButton] = useState(false);
  const [editData, setEditData] = useState<any>("");
  const [item, setItem] = useState<any>("");
  const [openQuesclosePopup, setopenQuesclosePopup] = useState(false);
  const [openQuesDeletePopup, setopenQuesDeletePopup] = useState(false);
  const { isMobile = false } = props;
  const [isBackButtonClicked, setBackbuttonPress] = useState(false);
  const [isListening, setIsListening] = useState<boolean>(false);
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener("popstate", onBackButtonEvent);
    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionValue, questionArr, isBackButtonClicked]);

  const startListening = () => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      props.setShowSnakbar(true);
      props.setSnakbarMsg("Speech Recognition  is not supported in this browser.");
      props.setMsgType("error");
      return;
    }
    if (!isListening) {
      const recognition = new SpeechRecognition();
      recognition.lang = "en-US"; // Set the language
      recognition.interimResults = false; // Set to true if you want partial results
      recognition.continuous = false; // Set to true for continuous listening
      recognitionRef.current = recognition;
      recognition.start();
      setIsListening(true);
      // Auto-focus text area when listening starts
      setTimeout(() => {
        textAreaRef.current?.focus();
      }, 100);
      recognition.onresult = (event) => {
        const spokenText = event.results[0][0].transcript;
        setQuestionValue((questionValue ? questionValue + "\n" : "") + spokenText);
        // setText(spokenText);
        setIsListening(false);
      };

      recognition.onerror = (event) => {
        console.error("Error occurred in recognition:", event.error);
        setIsListening(false);
      };

      recognition.onend = () => {
        setIsListening(false);
      };
      // Stop listening after 30 seconds
      timeoutRef.current = setTimeout(() => {
        recognition.stop();
        setIsListening(false);
      }, 30000);
    }

  };

  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (!isBackButtonClicked) {
      setBackbuttonPress(true);
      checkForUpdates();
    }
  };
  const checkForUpdates = () => {
    let newQuestions = questionArr.filter((it) => it);
    if (props?.isEdit) {
      if (
        JSON.stringify(newQuestions) === JSON.stringify(editData?.answers) &&
        questionValue === ""
      ) {
        handleCloseStartModal();
      } else {
        setopenQuesclosePopup(true);
      }
    } else if (
      newQuestions?.length <= 0 &&
      (questionValue === "" || !questionValue || !questionValue.trim())
    ) {
      handleCloseStartModal();
    } else {
      setopenQuesclosePopup(true);
    }
  };
  const handleCloseStartModal = async () => {
    if(outcomeState.tutorialVisible) {
      return
    }
    if (recognitionRef.current) {
      recognitionRef.current.stop();
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setStartModal(false);
    await props.setOpenRefQuesModal(false);
    props.setRefId("");
    if (!props?.isEdit && outcomeState?.isPersonal) {
      setTimeout(() => {
        // props?.renderToNextInput();
      }, 500);
    }
  };

  const handleDeleteEntry = () => {
    let payload = {
      reflectiveId: editData?.reflectiveId,
      date: props?.headerDate,
    };
    if (!outcomeState?.isPersonal) {
      const foundOutcome = (outcomeState?.reflectiveList || []).find(
        (it) => it.reflectiveId === payload.reflectiveId
      );
      if (foundOutcome) {
        const journyList = { ...(outcomeState?.journeyList || {}) } as any;
        const foundDateItemIcon = journyList.reflective_data.findIndex(
          (it) =>
            it.reflectiveId === payload.reflectiveId &&
            it?.date === payload.date
        );
        if (foundDateItemIcon > -1) {
          journyList.reflective_data.splice(foundDateItemIcon, 1);
        }
        UserTypeDispatch(addJourneyAction(journyList as any));

      }
    } else {
      const journeyCategoryList = [
        ...(outcomeState?.journeyCategoryList || []),
      ];
      const foundOutcome = (journeyCategoryList || []).findIndex(
        (it) =>
          it.reflectiveIds &&
          it.reflectiveIds.includes(payload.reflectiveId)
      );
      if (foundOutcome > -1) {
        if (
          journeyCategoryList[foundOutcome].alls &&
          journeyCategoryList[foundOutcome].alls.length
        ) {
          const foundIndex = journeyCategoryList[
            foundOutcome
          ].alls.findIndex(
            (it) => it.reflectiveId === payload.reflectiveId
          );
          if (foundIndex > -1) {
            if (
              journeyCategoryList[foundOutcome].alls[foundIndex]
                .reflectiveResponses &&
              journeyCategoryList[foundOutcome].alls[foundIndex]
                .reflectiveResponses.length
            ) {
              const foundDateValue = journeyCategoryList[foundOutcome].alls[
                foundIndex
              ].reflectiveResponses.findIndex(
                (it) => it._id.date === payload.date
              );
              if (foundDateValue > -1) {
                journeyCategoryList[foundOutcome].alls[
                  foundIndex
                ].reflectiveResponses.splice(foundDateValue, 1);
              }
            }
            UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));

          }
        }
      } else {
        const foundOther = (journeyCategoryList || []).findIndex(
          (it) => it.name === "Other"
        );
        if (foundOther > -1) {
          const outcomeFound = journeyCategoryList[
            foundOther
          ].reflectives.findIndex(
            (it) => it.reflectiveId === payload.reflectiveId
          );
          if (outcomeFound > -1) {
            if (
              journeyCategoryList[foundOther].reflectives[outcomeFound]
                .reflectiveResponses &&
              journeyCategoryList[foundOther].reflectives[outcomeFound]
                .reflectiveResponses.length
            ) {
              const foundDateValue = journeyCategoryList[
                foundOther
              ].reflectives[outcomeFound].reflectiveResponses.findIndex(
                (it) => it._id.date === payload.date
              );
              if (foundDateValue > -1) {
                journeyCategoryList[foundOther].reflectives[
                  outcomeFound
                ].reflectiveResponses.splice(foundDateValue, 1);
              }
            }
            UserTypeDispatch(addCategoryJourneyAction(journeyCategoryList));

          }
        }
      }
      const foundOutcomeRefPersonal = (outcomeState?.reflectiveList || []).find(
        (it) => it.reflectiveId === payload.reflectiveId
      );
      if (foundOutcomeRefPersonal) {
        const journyList = { ...(outcomeState?.journeyList || {}) } as any;
        const foundDateItemIcon = journyList.reflective_data.findIndex(
          (it) =>
            it.reflectiveId === payload.reflectiveId &&
            it?.date === payload.date
        );
        if (foundDateItemIcon > -1) {
          journyList.reflective_data.splice(foundDateItemIcon, 1);
        }
        UserTypeDispatch(addJourneyAction(journyList as any));

      }
    }
    trackingService
      .deleteRefQuesRes(outcomeState.token, payload)
      .then((data) => {
        if (props.callToGetData) {
          props?.callService(false);
        }
        // setShowLoadingBtn(false);
        props.setShowSnakbar(false);
        props.setSnakbarMsg(data?.message);
        props.setOpenRefQuesModal(false);
        // props?.callService();
        props.setMsgType("success");
      })
      .catch((error) => {
        // setShowLoadingBtn(false);
        props.setShowSnakbar(true);
        props.setSnakbarMsg(
          error?.response?.data?.description
            ? error?.response?.data?.description
            : error?.message
        );
        props.setMsgType("error");
      });
  };

  let arr2: any = [];

  const handleRemove = (index) => {
    setQuestionArr(questionArr.filter((que) => que !== questionArr[index]));
  };
  const onKeyDownHandler = (e) => {
    let keyPress = e.ctrlKey || e.altKey;
    const answers = questionValue === "" || questionValue === "\n"
      ? questionArr.filter((it) => it && it !== "\n")
      : [...questionArr, questionValue].filter((it) => it && it !== "\n")

    if (keyPress && [65, 85, 13].includes(e.keyCode)) {
      let disable = false;

      if (questionValue === "" || questionValue === "\n") {
        disable = questionArr.length <= 0;
      }
      if (!disable) {
        createRefResponse();
      }
    } else if (!keyPress && [13].includes(e.keyCode)) {
      // if (questionValue && questionValue.length && !isMobile) {
      //   arr2 = [...questionArr];
      //   arr2.push(questionValue);
      //   setQuestionArr(arr2);
      //   setQuestionValue("");
      // }
    } else if (keyPress && [75].includes(e.keyCode) && !(answers && answers.length)) {
      props.setOpenRefQuesModal(false);
      setTimeout(() => {
        props?.renderToNextInput(true);
      }, 200);
    } else if (keyPress && [13].includes(e.keyCode)) {
      // setQuestionValue(questionValue + "\n")
    }
  };
  const createRefResponse = () => {
    let answers = questionValue === "" || questionValue === "\n"
      ? questionArr
        .filter((it) => it && it !== "\n")
        .join("\n")
        .split("\n")
      : [...questionArr, questionValue]
        .filter((it) => it && it !== "\n")
        .join("\n")
        .split("\n")
    if (answers.length && isMobile) {
      // answers = answers[0].split("\n").filter((it) => it && it !== "\n")
    }
    answers = answers.filter(Boolean)
    if (answers && answers.length) {
      setShowLoadingButton(true);
      let bodyData = {
        reflectiveId: props.refId,
        answers: answers,
        date: props?.headerDate,
      };

      trackingService
        .refQuesCreate(outcomeState.token, bodyData)
        .then((data: UpdateUserLevelModal) => {
          setShowLoadingButton(false);
          // props.setShowSnakbar(false);
          // props.setSnakbarMsg(data?.message);
          props.setOpenRefQuesModal(false);
          if (props?.pushIntoData) {
            props?.pushIntoData(bodyData);
            // if (!props?.isEdit) {
            setTimeout(() => {
              props?.renderToNextInput(true);
            }, 500);
            // }
          }
          props?.callService && isMobile && props?.callService(false);
          // props?.callService();
          // props.setMsgType("success");
        })
        .catch((error) => {
          setShowLoadingButton(false);
          props.setShowSnakbar(true);
          props.setSnakbarMsg(
            error?.response?.data?.description
              ? error?.response?.data?.description
              : error?.message
          );
          props.setMsgType("error");
        });
    } else {
      props.setOpenRefQuesModal(false);
      setTimeout(() => {
        props?.renderToNextInput(true);
      }, 200);
    }
  };
  useEffect(() => {
    if (props.item?.reflectiveId) {
      props?.setIsEdit(false);
      setQuestionArr([]);
      const outcomeGetData = {
        reflectiveId: props.item?.reflectiveId,
        date: props?.headerDate,
      };
      trackingService
        .getRefQues(outcomeState.token, outcomeGetData)
        .then((data) => {
          setItem(data?.data);
          if (!data?.data) {
            props?.setIsEdit(false);
            setQuestionArr([]);
          } else {
            props?.setIsEdit(true);
            setEditData(data?.data);
            // setQuestionArr(data.data.answers);
            let notes = data.data.answers;
            setQuestionValue(notes.join("\n"));
          }
        })
        .catch((error) => {
          console.log("answer response get error");
        });
    }
    // inputRef.current && inputRef.focus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item?.reflectiveId]);

  const setEditQuestionValue = (value, index) => {
    let temp = [...questionArr];
    temp[index] = value;
    setQuestionArr(temp);
  };

  const width = useWidth();

  let newQuestions = isMobile ? [] : questionArr.filter((it) => it && it !== "\n");
  return (
    <Grid>
      <form onKeyDown={onKeyDownHandler}>
        <AddUpdateEventModal
          onClose={
            props?.isEdit
              ? questionValue ===
                editData?.answers?.join("\n") || questionValue === ""
                ? handleCloseStartModal
                : outcomeState.tutorialVisible ? () => {} : () => {
                  setopenQuesclosePopup(true);
                }
              : newQuestions?.length <= 0 &&
                (questionValue === "" ||
                  !questionValue ||
                  !questionValue.trim())
                ? handleCloseStartModal
                : outcomeState.tutorialVisible ? () => {} : () => {
                  setopenQuesclosePopup(true);
                }
          }
          isDarkMode={outcomeState.isDarkMode}
          isReflective
          onSave={createRefResponse}
          showTitle
          showCloseIcon
          isMobile={props.isMobile}
          paperProps={
            false
              ? {
                height: "50vh",
              }
              : {
                width: "360px"
              }
          }
          title={
            <>
              {false ? (
                <>
                  {props?.isEdit ? "Update Tracking Event" : "Add Tracking Event"}
                  {editData?.reflectiveId && (
                    <IconButton
                      onClick={() => {
                        setopenQuesDeletePopup(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </>) : <CommonTypo size={24} lineHeight={28.8} fontWeight={700} color="var(--color-text-primary)"> {props?.isEdit ? "Update Tracking Event" : "Add Tracking Event"}</CommonTypo>}
            </>
          }
          deleteIcon={editData?.reflectiveId && (
            <IconButton
              onClick={() => {
                setopenQuesDeletePopup(true);
              }}
            >
              <DeleteIcon color="var(--color-text-primary)" size="24" />
            </IconButton>
          )}
          showMicIcon={true}
          micIcon={<IconButton
            onClick={() => {
              startListening()
            }}
          >
            {isListening ? <MicIcon color="var(--color-text-primary)" size="24" /> : <MicOffIcon color="var(--color-text-primary)" size="24" />}

          </IconButton>}
          showLoadingBtn={showLoadingButton}
          visible={openStartModal}
          buttonText={
            props?.isEdit ? (
              <span>
                <span style={{ textDecoration: "underline" }}>U</span>pdate
              </span>
            ) : newQuestions.length === 0 &&
              (questionValue === "" || questionValue === "\n") ? (
              <span>
                S<span style={{ textDecoration: "underline" }}>k</span>ip
              </span>
            ) : <span>
              <span style={{ textDecoration: "underline" }}>A</span>dd
            </span>
          }
          saveDisabled={
            props?.isEdit ? newQuestions.length === 0 &&
              (questionValue === "" || questionValue === "\n") : false
          }
        >
          {/* {isMobile && editData?.reflectiveId && (
            <div
              style={{
                position: "absolute",
                right: 0,
                top: 0,
              }}
            >
              <IconButton
                onClick={() => {
                  setopenQuesDeletePopup(true);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          )} */}
          <div
            style={{
              display: "flex",
              padding: true ? "0px" : "24px 32px 0px 32px",
              flexDirection: "column",
              alignItems: true ? "flex-start" : "center",
              gap: true ? "16px" : "16px",
              alignSelf: "stretch",
            }}
          >
            {true ? <CommonTypo size={props.isMobile ? 16 : 18} lineHeight={props.isMobile ? 25.6 : 21.6} fontWeight={400} color="var(--color-text-primary)"> {props?.item?.question || "Name"}</CommonTypo> :
              <Typography
                variant="body1"
                component="div"
                sx={
                  isMobile
                    ? {
                      color: palette.primary.light,
                      fontSize: `${pxToRem(20)} !important`,
                      lineHeight: "125% !important",
                      maxWidth: "90%",
                      textAlign: "justify !important",
                      fontWeight: `500 !important`,
                      "&.MuiTypography-root": {
                        "@media  (max-width: 600px) and (min-width: 100px)": {
                          fontSize: `${pxToRem(20)} !important`,
                          lineHeight: "125% !important",
                        },
                      },
                    }
                    : {
                      fontWeight: 600,
                      fontSize: `${pxToRem(24)} !important`,
                      color: palette.common.black,
                      lineHeight: "135% !important",
                      textAlign: "center",
                      width: "100%",
                    }
                }
              >
                {props?.item?.question}
              </Typography>}
          </div>
          <div
            style={{
              display: "flex",
              padding: true ? "0px" : "20px 32px 32px 32px",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "16px",
              alignSelf: "stretch",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "16px",
                alignSelf: "stretch",
              }}
            >
              {false && Array.isArray(newQuestions) && newQuestions?.length > 0 && <ul className={classes.listItemNotes}>
                {false && Array.isArray(newQuestions) && newQuestions?.length > 0 &&
                  newQuestions?.map((que: string, index: number) => {
                    return (
                      <li
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          position: "relative",
                        }}
                      >
                        {/* <TextField
                          variant="outlined"
                          multiline={que.length > 30 ? true : false}
                          minRows={que.length > 30 ? 4 : 1}
                          className={width > 768 ? "textarea " : "textarea"}
                          placeholder={ "Add a answers..."}
                          onChange={(e) =>
                            setEditQuestionValue(e.target.value, index)
                          }
                          sx={{
                            paddingLeft: "20px",
                            width: '100%',
                            marginBottom: '0px !important'
                          }}
                          value={que}
                          InputProps={{
                            endAdornment: <Button onClick={() => handleRemove(index)}>
                              <ModalCloseIcon />
                            </Button>
                          }}
                        /> */}
                        <TextareaAutosize
                          // variant="outlined"
                          className={
                            "textarea " +
                            (true
                              ? classes.textareaMobile
                              : classes.textarea) +
                            " " +
                            classes.paddingRight
                          }
                          // fullWidth
                          placeholder="Add a answers..."
                          // multiline
                          minRows={1}
                          maxRows={3}
                          // sx={{
                          //   '& .MuiOutlinedInput-root': {
                          //     minHeight: '96px',
                          //     resize: "auto",
                          //     padding: '20px',
                          //     // gap: '12px',
                          //     // flex: '1 0 0',
                          //     borderRadius: '12px !important',
                          //     border: '1px solid #EDEDED',
                          //     background: '#FFF',
                          //     '& .MuiInputBase-input': {
                          //       // padding: `0px !important`,
                          //       resize: "auto",

                          //     }
                          //   },
                          // }}
                          onChange={(e) =>
                            setEditQuestionValue(e.target.value, index)
                          }
                          value={que}
                        // InputProps={{
                        //   endAdornment: <Button onClick={() => handleRemove(index)}>
                        //     <ModalCloseIcon />
                        //   </Button>
                        // }}
                        />
                        <Button
                          onClick={() => handleRemove(index)}
                          style={{
                            position: "absolute",
                            right: 5,
                            top: 0,
                          }}
                          sx={{
                            "&.MuiButton-root": isMobile ? {
                              padding: "8px !important",
                            } : {},
                          }}
                        >
                          <ModalCloseIcon />
                        </Button>
                      </li>
                    );
                  })}
              </ul>}
              {false ? (
                <Typography
                  variant="caption"
                  component="p"
                  className={classes.pageTitle}
                  sx={{
                    color: palette.primary.light,
                    fontSize: `${pxToRem(16)} !important`,
                    lineHeight: "125% !important",
                    // textAlign: "center !important",
                    fontWeight: `500 !important`,
                    "&.MuiTypography-root": {
                      "@media  (max-width: 600px) and (min-width: 100px)": {
                        fontSize: `${pxToRem(16)} !important`,
                        lineHeight: "125% !important",
                      },
                    },
                  }}
                >
                  Your answer
                </Typography>
              ) : null}
              {props.isMobile ? (
                <TextareaAutosize
                  // variant="outlined"
                  className={
                    "textarea " +
                    (true ? classes.textareaMobile : classes.textarea)
                  }
                  // fullWidth
                  placeholder={props.isMobile ? "Add comment..." : "Add a answers..."}
                  // multiline
                  minRows={4}
                  maxRows={true ? 4 : undefined}
                  // autoFocus
                  ref={(input) => {
                    if (input) textAreaRef.current = input
                    if (input && !isFocused) {
                      if(!isMobile) {
                        input.focus();
                      }
                      // setQuestionValue("");
                      input.value = "";
                      setTimeout(() => {
                        setIsFocused(true);
                      }, 500);
                    }
                    // input && input.focus()
                  }}
                  onChange={(e) => {
                    if (e.target.value === '\n') e.target.value = ''
                    setQuestionValue(
                      e.target.value
                        ? e.target.value.replace(/å/g, "")
                        : e.target.value
                    );
                  }}
                  value={questionValue}
                />
              ) : (
                <TextareaAutosize
                  // variant="outlined"
                  className={
                    "textarea " +
                    (classes.textarea)
                  }
                  // fullWidth
                  placeholder={"Add comment..."}
                  // multiline
                  minRows={4}
                  maxRows={4}
                  autoFocus
                  ref={(input) => {
                    if (input) textAreaRef.current = input
                    if (input && !isFocused) {
                      input.focus();
                      // setQuestionValue("");
                      input.value = "";
                      setTimeout(() => {
                        setIsFocused(true);
                      }, 500);
                    }
                    // input && input.focus()
                  }}
                  onChange={(e) => {
                    if (e.target.value === '\n') e.target.value = ''
                    setQuestionValue(
                      e.target.value
                        ? e.target.value.replace(/å/g, "")
                        : e.target.value
                    );
                  }}
                  value={questionValue || ""}
                />
              )}

              {false && <div
                style={
                  isMobile
                    ? {
                      display: "flex",
                      padding: "8px 12px",
                      alignItems: "center",
                      gap: "4px",
                      borderRadius: "16px",
                      background: "var(--color-new-main-shadow)",
                      cursor: "pointer",
                      marginBottom: "32px",
                    }
                    : {
                      display: "flex",
                      padding: "8px 12px",
                      alignItems: "center",
                      gap: "4px",
                      borderRadius: "16px",
                      background: "var(--color-new-main-shadow)",
                      cursor: "pointer",
                    }
                }
                onClick={() => {
                  if (questionValue && questionValue.length) {
                    arr2 = [...questionArr];
                    arr2.push(questionValue);
                    setQuestionArr(arr2);
                    setQuestionValue("");
                  }
                }}
              >
                <Typography
                  variant="body1"
                  component="div"
                  sx={{
                    fontWeight: 400,
                    fontSize: `${pxToRem(12)} !important`,
                    color: "var(--button-active-text)",
                    lineHeight: "135%",
                    textAlign: "center",
                    width: "100%",
                  }}
                >
                  Add more
                </Typography>
              </div>}
            </div>
          </div>
        </AddUpdateEventModal>
      </form>
      {openQuesDeletePopup && (
        <QuesclosePopup
          open={openQuesDeletePopup}
          isDelete={openQuesDeletePopup}
          setopenQuesclosePopup={setopenQuesDeletePopup}
          handleCloseStartModal={handleDeleteEntry}
          setBackbuttonPress={setBackbuttonPress}
        />
      )}
      <QuesclosePopup
        open={openQuesclosePopup}
        setopenQuesclosePopup={setopenQuesclosePopup}
        handleCloseStartModal={handleCloseStartModal}
        setBackbuttonPress={setBackbuttonPress}
      />
    </Grid>
  );
};
export default AddRefQuesModal;
